import { useMutation, useQueryClient } from 'react-query';
import { thematicPackageStatuses } from '../cassandra-shared-js/thematic-package-statuses';
import { useItem } from './atoms/item-hook';
import CollectionKeys from './molecules/collection-keys';
import axiosClient from '../http/axios-client';

export const useThematicPackageRoadmap = (id) => {
  const {
    item: thematicPackage,
    itemIsLoading: thematicPackageLoading,
  } = useItem(CollectionKeys.THEMATIC_PACKAGES, id);

  const queryClient = useQueryClient();

  const {
    mutateAsync: proceedThematicPackage,
  } = useMutation(
    [ CollectionKeys.THEMATIC_PACKAGES, id, 'PROCEED' ],
    (status) => {
      return axiosClient.put(`${ CollectionKeys.THEMATIC_PACKAGES }/${ id }/proceed`, {
        status,
      });
    }, {
      onSettled() {
        return queryClient.invalidateQueries([ CollectionKeys.THEMATIC_PACKAGES, id ]);
      },
    },
  );

  const acceptThematicPackageStatus = () => {
    return proceedThematicPackage('ACCEPT');
  };

  const rejectThematicPackageStatus = () => {
    return proceedThematicPackage('REJECT');
  };

  const statuses = thematicPackageStatuses;

  return {
    currentStatus: thematicPackage?.roadmap_status,
    statuses,
    roadmapLoading: thematicPackageLoading,
    acceptThematicPackageStatus,
    rejectThematicPackageStatus,
  };
};
